import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useUnifiedCustomers } from '../../lib/workspaceStore';
import { mediaSrc } from '../../lib/mediaUrl';

interface ActiveUsersProps {
  onClose: () => void;
}

function initials(name: string) {
  const p = name.trim().split(/\s+/).filter(Boolean);
  if (!p.length) return '?';
  if (p.length === 1) return p[0].slice(0, 2).toUpperCase();
  return (p[0][0] + p[p.length - 1][0]).toUpperCase();
}

export function ActiveUsers({ onClose }: ActiveUsersProps) {
  const customers = useUnifiedCustomers();

  return (
    <div className="p-6">
      <button type="button" onClick={onClose} className="mb-6 flex items-center text-gray-600 hover:text-gray-900">
        <ArrowLeft className="mr-2 h-5 w-5" />
        Back to Dashboard
      </button>
      <h2 className="mb-4 text-xl font-semibold text-gray-800">Workspace customers</h2>
      {customers.length === 0 ? (
        <p className="rounded-lg border border-dashed border-gray-200 bg-gray-50 py-8 text-center text-sm text-gray-600">
          No customers yet. Data appears here from finance and hand-loan records.
        </p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {customers.map((user) => (
            <div key={user.id} className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
              <div className="flex items-center space-x-4">
                {user.avatar ? (
                  <img src={mediaSrc(user.avatar)} alt="" className="h-12 w-12 shrink-0 rounded-full object-cover" />
                ) : (
                  <div
                    className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-zinc-200 text-sm font-semibold text-zinc-700"
                    aria-hidden
                  >
                    {initials(user.name)}
                  </div>
                )}
                <div className="min-w-0">
                  <h3 className="truncate text-sm font-medium text-gray-900">{user.name}</h3>
                  <p className="truncate text-sm text-gray-500">{user.email}</p>
                  <p className="mt-1 text-xs text-gray-400">
                    {user.pendingEmi?.dueDate && user.pendingEmi.dueDate !== '—'
                      ? `Next due ${user.pendingEmi.dueDate}`
                      : 'No upcoming EMI on schedule'}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
